<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="clientes"
      :loading="loading"
      :server-items-length="total"
      @update:options="updateOptions"
      :options.sync="opts"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('cliente.criar_clientes')"
            depressed
            color="accent"
            :to="{ name: 'cliente-formulario' }"
          >
            <v-icon class="mdi mdi-account-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.tipo="{ item }">
        <span class="caption">{{
          item.tipo === "F" ? "Pessoa física" : "Pessoa júridica"
        }}</span>
        <br />
        {{ strDocumento(item) }}
      </template>
      <template v-slot:item.id_vendedor="{ item }">{{
        item.vendedor ? item.vendedor.nome : "-"
      }}</template>
      <template v-slot:item.ativo="{ item }">
        <v-icon>{{
          item.ativo
            ? "mdi-checkbox-marked-outline"
            : "mdi-checkbox-blank-outline"
        }}</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu offset-y v-model="menu[item.id]">
          <template v-slot:activator="{ on }">
            <v-btn icon small text v-on="on" @click="$set(menu, item.id, true)">
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card width="150">
            <v-row justify="space-around" class="pa-3">
              <botao-contatos
                :params="{
                  id_entidade: item.id,
                  tipo_entidade: 'clientes',
                  titulo: 'Contatos de ' + item.nome,
                }"
              />
              <lista-enderecos-dialog
                tipo="clientes"
                :id-entidade="item.id"
                :title="`Endereços de ${item.nome}`"
                @open="$set(menu, item.id, false)"
              />
              <lista-documentos-dialog
                :title="`Documentos de ${item.nome}`"
                :id-proprietario="item.id"
                url-base="clientes"
                @open="$set(menu, item.id, false)"
              />
            </v-row>
          </v-card>
        </v-menu>
        <v-btn
          v-if="perms.includes('cliente.criar_clientes')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('cliente.excluir_clientes')"
          titulo="Deletar cliente"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
    <contato-dialog />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import ListaDocumentosDialog from "../components/documentos/ListaDocumentosDialog";
import ListaEnderecosDialog from "../components/entidades/ListaEnderecosDialog";
import ContatoDialog from "../components/contatos/ContatoDialog";
import BotaoContatos from "../components/contatos/BotaoContatos";
export default {
  components: {
    DatatableFilters,
    DialogConfirm,
    ListaEnderecosDialog,
    ListaDocumentosDialog,
    ContatoDialog,
    BotaoContatos,
  },
  data() {
    return {
      headers: [
        { text: "#", value: "id" },
        { text: "Tipo", value: "tipo" },
        { text: "Nome / Nome fantasia", value: "nome" },
        { text: "Razão social", value: "razao_social" },
        { text: "Vendedor responsável", value: "id_vendedor" },
        { text: "Ativo", value: "ativo", sortable: false, align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "pesquisa",
          label: "Pesquisa geral",
          type: "text",
          defaultValue: "",
        },
        {
          name: "cpf_cnpj",
          label: "CPF / CNPJ",
          type: "text",
          defaultValue: "",
        },
        {
          name: "nome",
          label: "Nome / Nome fantasia",
          type: "text",
          defaultValue: "",
        },
        {
          name: "razao_social",
          label: "Razão social",
          type: "text",
          defaultValue: "",
        },
        {
          name: "id_vendedor",
          label: "Vendedor responsável",
          type: "select",
          options: [],
        },
        {
          name: "ativo",
          label: "Ativo",
          type: "switch",
          options: {
            trueValue: "Sim",
            falseValue: "Não",
          },
          defaultValue: true,
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.clientes") || `{"ativo" : true}`
      ),
      loading: true,
      menu: [],
      opts: {
        itemsPerPage: 10,
        page: 1,
        sortBy: ["id"],
        sortDesc: [true],
      },
    };
  },
  computed: mapState({
    total: (state) => state.cliente.clientes.total,
    clientes: (state) => state.cliente.clientes.clientes,
    perms: (state) => state.usuarios.usuarioAtivo.permissoes,
  }),
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("cliente/deletar", id);
      this.listar(this.opts);
    },
    editar(id) {
      this.$router.replace({
        name: "cliente-formulario-editar",
        params: { id },
      });
    },
    async listar(options) {
      this.loading = true;
      try {
        let ordenacao = options.sortBy[0];
        if (options.sortDesc[0]) {
          ordenacao += " desc";
        }

        await this.$store.dispatch("cliente/listar", {
          filtros: this.filtrosAtivos,
          carregarVendedor: true,
          pagina: options.page,
          por_pagina: options.itemsPerPage,
          ordenacao,
        });
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar a lista de clientees",
        });
      }
      this.loading = false;
    },
    strDocumento(cliente) {
      const doc = cliente.cpf_cnpj;
      if (cliente.tipo === "F") {
        return `${doc.substr(0, 3)}.${doc.substr(3, 3)}.${doc.substr(
          6,
          3
        )}-${doc.substr(-2)}`;
      } else {
        return `${doc.substr(0, 2)}.${doc.substr(2, 3)}.${doc.substr(
          5,
          3
        )}/${doc.substr(8, 4)}-${doc.substr(-2)}`;
      }
    },
    updateOptions(opts) {
      this.listar(opts);
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.clientes", JSON.stringify(val));
      this.opts.page = 1;
      this.listar(this.opts);
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de clientes",
    });

    this.$store.dispatch("vendedor/listar", {}).then((vendedores) => {
      this.filters.find(
        (f) => f.name === "id_vendedor"
      ).options = vendedores.map((v) => ({
        text: v.nome,
        value: v.id,
      }));
    });
  },
};
</script>
